import React, {useEffect} from 'react';
import {useLegalEmployeesAPIs} from "../../api/LegalEmployee";
import LimitsView from "./LimitsView";
import {useSelector} from "react-redux";
import BlurLoading from "../../components/BlurLoading";
import MerchantSkeleton from "../../components/skeletons/MerchantSkeleton";

function Settings({activeButton, setActiveButton}) {
    const {flag, loading} = useSelector(state => state.transferResponse);

    const {
        GetEmployeeLimitation,
        employeeLimits,
        limitsLoading
    } = useLegalEmployeesAPIs();

    useEffect(() => {
        GetEmployeeLimitation();
    }, []);

    useEffect(() => {
        if ([0, 1].includes(flag)) {
            GetEmployeeLimitation();
        }
    }, [flag]);

    return (
        <>
            {
                limitsLoading ?
                    <div>
                        <MerchantSkeleton/>
                        <MerchantSkeleton/>
                    </div> :
                    <>
                        {loading==="pending" && <BlurLoading/>}
                        <LimitsView limits={employeeLimits}/>
                    </>
            }
        </>
    );
}

export default Settings;

